import React from 'react';
import './error.less';

const Error = () => {
  return (
    <div className="container">
      <div className="red-title-img-container">
        <img
          className="red-title-img"
          src={`https://${window.okGlobal.cdnBaseUrl}/cdn/assets/imgs/common/waiting.png`}
        />
      </div>
      <div className="red-title-text">問題が発生しました</div>
      <div className="content">
        しばらく時間をおいてから再度お試しください。
      </div>
      <div className="content">
        何度も発生する場合は、お手数ですが下記のメールアドレスにご連絡ください。
      </div>
      <div className="content" style={{ lineHeight: '30px' }}>
        <a className="content-url" href="mailto:support@okcoin.jp">
          support@okcoin.jp
        </a>
      </div>
    </div>
  );
};

export default Error;
